import React from 'react'
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'semantic-ui-react'
import { FarmersOptionsType } from '~/api/services/farmers'

interface Props {
  dataFiltered: any
  farmersListOptions: FarmersOptionsType
  handleChangeData: (data: any) => void
}

const LocationFilters:React.FC<Props> = (props) => {
  const {
    dataFiltered,
    farmersListOptions,
    handleChangeData
  } = props
  const { t } = useTranslation()

  const { stateId } = dataFiltered

  const selectedState = farmersListOptions?.states?.find(state => state.id === stateId)
  const stateOptions = farmersListOptions?.states?.map(state => ({ value: state.id, text: state.label }))

  return <>
    <Dropdown
      placeholder={t('State')}
      search
      selectOnBlur={false}
      selection
      value={dataFiltered.stateId}
      noResultsMessage={t('No results found....')}
      style={{ width: 220 }}
      options={stateOptions || []}
      clearable
      onChange={((e, data) => {
        handleChangeData({
          ...dataFiltered,
          stateId: data.value,
          districtId: '',
          agricultureDistrictId: ''
        })
      })}
    />
    {selectedState?.districts?.length > 0 && <Dropdown
      placeholder={t('District / Independent city')}
      search
      disabled={!selectedState}
      selection
      style={{ width: 220 }}
      clearable
      value={dataFiltered.districtId}
      selectOnBlur={false}
      onChange={((e, data) => {
        handleChangeData({
          ...dataFiltered,
          districtId: data.value,
          agricultureDistrictId: ''
        })
      })}
      noResultsMessage={t('No results found....')}
      options={selectedState?.districts.map(district => ({ text: `${district.name} (${district.zip})`, value: district.id })) || []}
    />}
    {selectedState?.agricultureDistricts?.length > 0 && <Dropdown
      selectOnBlur={false}
      selection
      disabled={!selectedState}
      clearable
      style={{ width: 250 }}
      value={dataFiltered.agricultureDistrictId}
      onChange={((e, data) => {
        handleChangeData({
          ...dataFiltered,
          agricultureDistrictId: data.value
        })
      })}
      placeholder={t('LWA / District No.')}
      options={selectedState?.agricultureDistricts.map(agricultureDistrict => ({ text: `${agricultureDistrict.name} (${agricultureDistrict.number})`, value: agricultureDistrict.id })) || []}
    />}
  </>
}
export default LocationFilters